import { render, staticRenderFns } from "./JingquKoubei.vue?vue&type=template&id=1dffaad2&scoped=true&"
import script from "./JingquKoubei.vue?vue&type=script&lang=js&"
export * from "./JingquKoubei.vue?vue&type=script&lang=js&"
import style0 from "./JingquKoubei.vue?vue&type=style&index=0&id=1dffaad2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dffaad2",
  null
  
)

export default component.exports